/**
 * Checks whether a field is currently active (highlighted) in the editor.
 * activeFieldId can be a single string or an array when multiple fields
 * are highlighted simultaneously.
 */
export function isFieldActive(
  activeFieldId: string | readonly string[] | null | undefined,
  fieldId: string,
): boolean {
  if (activeFieldId == null) {
    return false
  }
  if (Array.isArray(activeFieldId)) {
    return activeFieldId.includes(fieldId)
  }
  return activeFieldId === fieldId
}
